console.log("slick-carousel-offerte.js");
import $ from 'jquery';

class carouselSliderOfferte {

  constructor() {
    this.offerta = $(".vetrina-offerte .elementor-posts-container,.slider-gallery .gallery");
    this.initCarousel();
  }

  initCarousel() {
    this.offerta.slick({
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: '2em',
      fade: false, 
      mobileFirst: true,
      arrows: true,
      prevArrow: '<span class="slick-prev"></span>',
      nextArrow: '<span class="slick-next"></span>',

      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
			autoplay: false,
            centerMode: false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
			autoplay: false
          }
        }
      ]

    });
  }
}

export default carouselSliderOfferte;